import $ from 'jquery'
import { isShow, isTopPage, isBg } from '../_variables'
import Screen from './screen'

const screen = new Screen()

export default class Header {
  constructor() {
    this.elm = document.querySelector('html')
  }

  init() {
    this.gnavi()
    this.closeMegaMenu()
    this.headerTop()
    this.spMenu()
  }

  // Click gnavi
  gnavi() {
    $('.p-gnavi__item').each((idx, elGnavi) => {
      const $this = $(elGnavi)
      const $btnGnavi = $this.find('.p-gnavi__textBox')
      const $megaMenu = $this.find('.p-gnaviContent')
      const $bgHeader = $('.l-header')
      const speed = 200

      // Click button to show mega menu
      $btnGnavi.on('click', e => {
        e.stopPropagation()

        if (screen.isPC) {
          this.resetMegaMenu()

          if ($megaMenu.is(':hidden')) {
            $megaMenu.stop().fadeIn(speed)
            $this.addClass(isShow)
            $bgHeader.addClass(isBg)

            // update matchHeight
            $.fn.matchHeight._update()
          }
        } else {
          $megaMenu.stop().slideToggle()
          $this.toggleClass(isShow)
          $bgHeader.removeClass(isTopPage)
        }
      })

      // resize
      $(window).on('breakpointChange', () => {
        $('.p-gnaviContent').stop().fadeOut(speed).removeAttr('style')
        $('.p-gnavi__item').removeClass(isShow)
        $('.l-header').removeClass(isBg)
      })
    })
  }

  // Reset mega menu
  resetMegaMenu() {
    const speed = 200
    $('.p-gnaviContent').stop().fadeOut(speed)
    $('.p-gnavi__item').removeClass(isShow)
    $('.l-header').removeClass(isBg)
  }

  // Click button to close mega menu
  closeMegaMenu() {
    $('html').on('click', e => {
      if (screen.isPC) {
        if ($(e.target).closest('.p-gnaviContent').length === 0) {
          const speed = 200
          $('.p-gnaviContent').stop().fadeOut(speed)
          $('.p-gnavi__item').removeClass(isShow)
          $('.l-header').removeClass(isBg)
        }
      }
    })
  }

  // header top
  headerTop() {
    if ($('body').is('#top')) {
      $('.l-header').addClass(isTopPage)

      $(window).on('scroll', () => {
        if ($(window).scrollTop() === 0) {
          $('.l-header').addClass(isTopPage)
        } else {
          $('.l-header').removeClass(isTopPage)
        }
      })
    }
  }

  // SP menu
  spMenu() {
    $('.p-headerMain__menu').on('click', e => {
      const $this = $(e.currentTarget)
      const $contentGnavi = $('.p-headerMain__content')
      const $bgHeader = $('.l-header')

      if (!screen.isPC) {
        $contentGnavi.stop().fadeToggle()
        $this.toggleClass(isShow)
        $bgHeader.toggleClass(isBg)

        if ($('body').is('#top')) {
          $bgHeader.toggleClass(isTopPage)
        }

        if ($this.hasClass(isShow)) {
          screen.lock()
        } else {
          screen.unlock()
        }
      }

      // resize
      $(window).on('breakpointChange', () => {
        if (screen.isPC) {
          $contentGnavi.removeAttr('style')
          $('.p-gnavi__item').removeClass(isShow)
          $('.p-headerMain__menu').removeClass(isShow)
          $('.p-gnaviContent').removeAttr('style')
          $('.l-header').removeClass(isBg)
          screen.unlock()
        }
      })
    })
  }
}
